import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string({required_error:"חובה להכניס כתובת מייל"}).nonempty("חובה להכניס כתובת מייל").email("כתובת מייל לא תקנית"),
  password: z.string({required_error:"חובה להכניס סיסמא"}).min(1,"חובה להכניס סיסמא")
})
export const forgotPasswordSchema = z.object({
  email: z
    .string({ required_error: "חובה להכניס כתובת אימייל" })
    .nonempty("חובה להכניס כתובת אימייל")
    .email("כתובת אימייל לא תקינה")
})

export const resetPasswordSchema = z.object({
  password: z
    .string({ required_error: "חובה להכניס סיסמה" })
    .min(8, "הסיסמה חייבת להכיל לפחות 8 תווים")
    .regex(/[A-Z]/, "הסיסמה חייבת להכיל לפחות אות גדולה אחת")
    .regex(/[a-z]/, "הסיסמה חייבת להכיל לפחות אות קטנה אחת")
    .regex(/[0-9]/, "הסיסמה חייבת להכיל לפחות מספר אחד")
    .regex(/[^A-Za-z0-9]/, "הסיסמה חייבת להכיל לפחות תו מיוחד אחד"),
  confirmPassword: z
    .string({ required_error: "חובה לאמת את הסיסמה" })
}).refine((data) => data.password === data.confirmPassword, {
  message: "הסיסמאות אינן תואמות",
  path: ["confirmPassword"],
})

export type loginInput = z.infer<typeof loginSchema>;
export type forgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
export type resetPasswordInput = z.infer<typeof resetPasswordSchema>;
